import type { CustomerMetric } from "../CustomerDetailsSidePanel/customerMetric";

export interface ProductGroupRef {
  id: string;
  name: string;
  externalReference: string | null;
}

export interface ProductDrillRoot {
  group: ProductGroupRef;
  initialMetric: CustomerMetric;
}

export const CHART_COLORS = ["#0017AE", "#001EE1", "#334EFF", "#A1A3ED", "#C6C6F3"];
